/* eslint-disable */
import React, { memo, useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import { Checkbox } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { utility } from "../../framework/utility/utilityProvider";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, ROLETYPE, SUBTITLETYPE, TX_MODE, VODTYPE } from "../../framework/constant/constant";
import SegmentTypeCollectionTab from "./SegemnetTypeCollectionTab";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { toast } from 'react-toastify';
import { CheckboxCell } from "../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import { useRef } from "react";
import { SegmentQC } from "./SegmentQC";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import RefreshButton from "../../framework/forms/helpercomponents/buttons/RefreshButton";
import MediaFastSegmentationPopup from "./MediaFastSegmentationPopup";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { collectionSegmentMenuModel } from "../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import MediaEpisodeHistory from "../Planning/MediaEpisodeHistory";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import BossDialog from "../../components/BossDialog";
import { ConfirmAlert } from "../../ConfirmAlert";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { MediaMamAssetColumns } from "../../framework/utility/customColumns";
import BucketCollectionSelection from "../BucketConfigurations/BucketCollectionSelection";

function MediaEpisodeSegmentEditForm(props) {

  const { segmentData = [], metaData = {} } = props;

  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const [segmentTypes, setSegmentTypes] = useState([]);
  const [mediaEpisodeSegments, setMediaEpisodeSegments] = useState(segmentData);
  const [segmentDetails, setSegmentDetails] = useState([]);
  const [editToggle, setEditToggle] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState([]);
  const [dialogTitle, setDialogTitle] = useState(lang.create_version_dialog_header);
  const [language, setLanguage] = useState([]);
  const [channels, setChannels] = useState([]);
  const [materialContent, setManageContent] = useState([]);
  const [versions, setVersions] = useState([]);
  const [showMamAssetCollectionSelection, setShowMamAssetCollection] = useState(false);
  const [showBucketCollectionSelection, setShowBucketCollectionSelection] = useState(false);
  const [transmissionTypes, setTransmissionTypes] = useState([]);

  const fileRef = useRef(null);
  const [file, setFile] = useState('');
  const [selectedFile, setSelectedFile] = useState(lang.select_file_label);
  const [showQCStatus, setShowQCStatus] = useState(false);
  const [fastSegmentationPopupOpen, setFastSegmentationPopupOpen] = useState(false);
  const [showSegmentHistory, setShowSegmentHistory] = useState(false);
  const [showChannelGroups, setShowChannelGroups] = useState(false);
  const segmentQCRef = useRef();
  const setSegementQCRef = (data) => {
    segmentQCRef.current = data;
  }

  const segmentHistoryRef = useRef();
  const setSegementHistoryRef = (data) => {
    segmentHistoryRef.current = data;
  }

  // company Data
  const companyData = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  let initialValue = {
    ActualDuration: utility.convertMilisecondsToStringWithFrames(0),
    SegmentType: {},
    SegmentNumber: companyData?.segByRc ? props?.mediaEpisodeEntity?.ReferenceCode : props.mediaEpisodeEntity.AssetId,
    fileupload: "",
    SegmentDetails: [],
    IsHardParted: false,
    IsDefault: false,
    Language: {},
    Subtitle: false,
    SubtitleType: {},
    TXReady: false,
    MaterialContent: {},
    Remarks: '',
    PgRating: {},
    Channels: [],
    Version: {},
    StorageDetails: {},
    TransmissionType: {},
    IngestPrototype: {},
    TranscodePrototype: {}
  }

  const [dataItem, setData] = useState(initialValue);
  const dataItemRef = useRef(initialValue);
  const defaultSegmentType = useRef({});
  const [pgRatings, setPgRatings] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [ingestPrototypes, setIngestPrototypes] = useState([]);
  const [transcodePrototypes, setTranscodePrototypes] = useState([]);

  const setDataItem = (data) => {
    dataItemRef.current = data;
    setData(data);
  }

  const MyCheckBoxCell = (props) => <CheckboxCell {...props} />;

  let segmentDetail = {
    Sequence: 0,
    MediaId: "",
    TcIn: '00:00:00:00',
    TcOut: '',
    Duration: '',
    IsPreviewed: false
  };

  useEffect(() => {
    loadcombo();

    if (props.mediaEpisodeEntity != undefined && props.mediaEpisodeEntity.SID > 0 && segmentData.length == 0) {
      loadSavedSegments();
    }

  }, [])

  const onChange = async (e) => {

    if (e.target.name == "fileupload") {
      setFile(e.target.files[0]);
      setSelectedFile(lang.select_file_label);
      setDataItem({ ...dataItem, File: e.target.files[0].name });
    } else if (e.target.name == "MaterialContent") {
      //check 
      let value = e.target.value
      const updatedContent = await API.getAndSaveMaterialContentNextHouseNumber(value.SID, { ...value, isSaveNextnumber: false });
      if (!updatedContent.success) return;
      console.log(!updatedContent.success);
      setDataItem({ ...dataItem, MaterialContent: value, SegmentNumber: updatedContent.data.HouseNumber });

      let tempSegmentNumber = dataItem.SegmentNumber.length == 0 ? props.mediaEpisodeEntity.AssetId : dataItem.SegmentNumber;
      setSegmentDetails(segmentDetails.map((x) => {
        return {
          ...x,
          MediaId: x.MediaId.replace(
            tempSegmentNumber,
            updatedContent.data.HouseNumber
          )
        }
      }));

    } else if (e.target.name == 'GenerateMaterialID') {
      if (e.target.value) {
        setDataItem({ ...dataItem, SegmentNumber: '', [e.target.name]: e.target.value })
      } else {

        if (dataItem.MaterialContent == undefined || Object.keys(dataItem.MaterialContent).length == 0) {
          setDataItem({ ...dataItem, SegmentNumber: props.mediaEpisodeEntity.AssetId, [e.target.name]: e.target.value })
          return;
        }

        setDataItem({
          ...dataItem,
          SegmentNumber: props.mediaEpisodeEntity.AssetId,
          [e.target.name]: e.target.value,
          MaterialContent: {}
        });
        setSegmentDetails(segmentDetails.map((x) => {
          return {
            ...x,
            MediaId: x.MediaId.replace(dataItem.SegmentNumber, props.mediaEpisodeEntity.AssetId)
          }
        }));

      }
    }
    else if (e.target.name === "IsAllChannel") {
      const newValue = !selectAllChannels;

      setSelectAllChannels(newValue);

      setDataItem({
        ...dataItem,
        Channels: newValue ? channels : [],
        AddFromChannelgroups: []
      });
    }
    else if (e.target.name == "MamID") {
      // setDataItem({ ...dataItem, [e.target.name]: e.target.value });
      props.handleMetaData({ ...metaData, MamID: e.target.value })
    }
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const onBrowseBucket = (dataList, bucket) => {
    setDataItem({
      ...dataItem,
      StorageDetails: {
        Bucket_id: bucket._id,
        FileName: dataList[0].name
      }
    });
  }

  const onDetachFile = () => {
    ConfirmAlert(
      () => onChange({ target: { name: "StorageDetails", value: {} } }),
      () => { },
      lang.confirm_button_text,
      lang.detach_file_confirmation_msg
    );
  }

  const loadcombo = async () => {

    // SEGMENT TYPE
    let segmentTypeRes = await API.getDataLookup(ENTITYNAME.SegmentType, { sort: { Description: 1 } });
    setSegmentTypes(segmentTypeRes.data);
    if (dataItemRef.current.SegmentType == undefined || dataItemRef.current.SegmentType._id == undefined) {
      defaultSegmentType.current = utility.getDefaultItem(segmentTypeRes.data);
      setDataItem({ ...dataItemRef.current, SegmentType: defaultSegmentType.current })
    }
    // SUBTITLE
    if (dataItem.Subtitle) {
      let res = await API.readFile(file);
      console.log(res);
    }
    // LANGUAGES
    let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguage(languageRes.data);
    // MATERIAL CONTENT
    let materialContentRes = await API.getData(ENTITYNAME.MaterialContent, { sort: { Description: 1 }, query: ["MediaCategory.SID", "=", props?.mediaEpisodeEntity?.MediaCategory?.SID] });
    setManageContent(materialContentRes.data);
    // PG Rating
    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);
    // Version 
    let versionRes = await API.getDataLookup(ENTITYNAME.Version, { sort: { Name: 1 } });
    setVersions(versionRes.data);
    // CHANNELS
    let channelRes = await API.getValidChannels();
    setChannels(channelRes.data);

    // TRANSMISSION TYPE
    const transmissionTypesRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { Description: 1 } });
    setTransmissionTypes(transmissionTypesRes.data);

    setDataItem(prev => {
      if (editMode && editItem?.TransmissionType) {
        return { ...prev, TransmissionType: Object.keys(editItem.TransmissionType).length > 0 ? editItem.TransmissionType : utility.getDefaultItem(transmissionTypesRes.data) };
      }
      return { ...prev, TransmissionType: utility.getDefaultItem(transmissionTypesRes.data) };
    });

    // INGEST PROTOTYPE
    const ingestPrototypeRes = await API.getDataLookup(ENTITYNAME.INGEST_PROTOTYPE, { sort: { Description: 1 } });
    setIngestPrototypes(ingestPrototypeRes.data);

    // TRANSCODE PROTOTYPE
    const transcodeprototypeRes = await API.getDataLookup(ENTITYNAME.TranscodePrototypes, { sort: { Description: 1 } });
    setTranscodePrototypes(transcodeprototypeRes.data);
  }

  const loadSavedSegments = async () => {

    let res = await API.getData(ENTITYNAME.MediaEpisodeSegment, { query: ['MediaEpisodeSID', '=', parseInt(props.mediaEpisodeEntity.SID)] });
    console.log(res.data);
    if (res.success) {
      setMediaEpisodeSegments(() => res.data);
      props.getSegmentData(res.data);
    }
  }

  //to get data from collection on edit
  const onEdit = (object) => {
    setEditToggle(true);
    setEditItem(object);
    setDialogTitle(`${lang.edit_version_dialog_header}`);

    let castedSegmentDetail = object.SegmentDetails.map(item => ({
      ...item, TcIn: utility.convertMilisecondsToStringWithFrames(item.TcIn),
      TcOut: utility.convertMilisecondsToStringWithFrames(item.TcOut),
      Duration: utility.convertMilisecondsToStringWithFrames(item.Duration),
      Remarks: item?.Remarks ?? ''
    }));

    setSegmentDetails(() => castedSegmentDetail);

    setDataItem(prev => ({
      ...object, ["ActualDuration"]: utility.convertMilisecondsToStringWithFrames(object.ActualDuration),
      TransmissionType: object?.TransmissionType && Object.keys(object?.TransmissionType).length > 0 ? object?.TransmissionType : prev?.TransmissionType
    }));
    setFile(object.File);

    setEditMode(() => true);

  }

  const handleGenerateSegmentClick = async (e) => {

    e.preventDefault();

    if (dataItem.SegmentNumber == undefined || dataItem.SegmentNumber == "") {
      toast.error(`${lang.please_enter_material_id_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    if (dataItem.GenerateMaterialID && (!dataItem.MaterialContent || Object.keys(dataItem.MaterialContent).length == 0)) {
      toast.error(`Select Material Content first`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    generateSegment();

  }

  const onSaveSegments = async (saveSegmentData) => {
    // Save Segments
    let res = await API.saveData(ENTITYNAME.MediaEpisodeSegment, { ...saveSegmentData, MediaEpisodeSID: props?.mediaEpisodeEntity?.SID });
    let segmentIndex = mediaEpisodeSegments.findIndex(x => x._id === saveSegmentData._id);
    if (segmentIndex == -1) {
      setMediaEpisodeSegments(() => [...mediaEpisodeSegments, { ...saveSegmentData, _id: res.data._id, SID: res.data.SID }])
      props.getSegmentData([...mediaEpisodeSegments, { ...saveSegmentData, _id: res.data._id, SID: res.data.SID }]);
    }

    // Auto Create MAM Asset and WO
    const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();
    if (isAutoCreateMAMAssetOnVersion) {
      let mamAssetResponse = await API.createMAMAssetFromVersion({ mediaIds: [props?.mediaEpisodeEntity?._id], entityName: ENTITYNAME.MediaEpisode });
      console.log(mamAssetResponse);
    }

    // if formats are attached we need to make sure segment of same format type is created in system
    await API.updateSegmentInPlanning(props?.mediaEpisodeEntity?._id);
  }

  const onAddSegment = async (isNewSegment) => {

    if (isNewSegment) {
      let filtereddata = mediaEpisodeSegments.some((item) =>
        item.SegmentType?.SID == dataItem.SegmentType?.SID &&
        item.Language?.SID == dataItem.Language?.SID &&
        item.SegmentType?.TXMode?.SID == dataItem.SegmentType?.TXMode?.SID);

      if (filtereddata) {
        toast.error(`${dataItem.SegmentType.Description} ${lang.version_label} ${lang.already_exists_global_error_message}`, {
          position: toast.POSITION.TOP_RIGHT
        });
        return;
      }
    }

    if (!dataItem.Channels || dataItem.Channels.length == 0) {
      toast.error(`${lang.please_select_channel_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    // isNewSegment true means new ,false means old edit
    if (!dataItem.SegmentType || segmentDetails.length == 0) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_generate_segments_first_media_episode_version_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return;
    }

    if (dataItem.SegmentType.SegmentCount != segmentDetails.length) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.generated_segments_selected_segmentType_mismatch_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return;
    }

    if (dataItem.Subtitle) {
      if (!dataItem.SubtitleType || Object.keys(dataItem.SubtitleType).length == 0) {
        toast.error(`${lang.please_select_subtitle_type_error_message}`, {
          position: toast.POSITION.TOP_RIGHT
        });
        return;
      }
      if (file == "" || file == undefined) {
        toast.error(`${lang.please_select_file_error_message}`, {
          position: toast.POSITION.TOP_RIGHT
        });
        return;
      }
    }

    if (dataItem.GenerateMaterialID && (!dataItem.MaterialContent || Object.keys(dataItem.MaterialContent).length == 0)) {
      toast.error(lang.select_material_content_first_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    // if(checkExceedingSlotDuration()) {
    //   toast.error(lang.exceeding_slot_duration_error_message, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return;
    // }

    // if(checkOverlappingTimecodes()) {
    //   toast.error(lang.overlapping_timecodes_error_message, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return;
    // }

    // check dataItem.SegmentNumber != segmentDetails.MediaId
    // let duplicateMediaID = segmentDetails.some((item) => {
    //   let mediaId = item.MediaId.split('-');
    //   return mediaId[0] != dataItem.SegmentNumber
    // });

    // if (duplicateMediaID) {
    //   toast.error(lang.material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return;
    // }

    //CHECK SEGMENT TYPE and MEDIA ID
    let duplicateMaterialID = mediaEpisodeSegments.some((item) =>
      item._id != dataItem._id &&
      item.SegmentType?.SID == dataItem.SegmentType?.SID &&
      item.SegmentNumber == dataItem.SegmentNumber);

    if (duplicateMaterialID) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.segment_already_exist_with_same_material_id_and_segment_type_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return;
    }

    if (checkInvalidTimecodes()) {
      toast.error(`${lang.invalid_duration_segment_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    segmentDetails.forEach((obj) => {
      delete obj.inEdit;
    })

    let materialID = dataItem.SegmentNumber;
    if (dataItem.GenerateMaterialID) {
      let id = await API.getAndSaveMaterialContentNextHouseNumber(dataItem.MaterialContent.SID, { ...dataItem.MaterialContent, isSaveNextnumber: true });
      materialID = id.data.HouseNumber
    }

    const saveSegmentData = {
      SID: dataItem?.SID ?? 0,
      SegmentType: dataItem?.SegmentType ? {
        _id: dataItem?.SegmentType?._id,
        SID: dataItem?.SegmentType?.SID,
        Description: dataItem?.SegmentType?.Description,
        Title: dataItem?.SegmentType?.Title,
        SegmentCount: dataItem?.SegmentType?.SegmentCount,
        TXMode: dataItem?.SegmentType?.TXMode ? {
          _id: dataItem?.SegmentType?.TXMode?._id,
          SID: dataItem?.SegmentType?.TXMode?.SID,
          Name: dataItem?.SegmentType?.TXMode?.Name
        } : {}
      } : {},
      Channels: dataItem?.Channels?.map((x) => {
        return { _id: x._id, SID: x.SID, FullChannelName: x.FullChannelName };
      }),
      ActualDuration: utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration),
      Language: dataItem?.Language && Object.keys(dataItem?.Language)?.length > 0 ? {
        _id: dataItem?.Language?._id,
        SID: dataItem?.Language?.SID,
        Description: dataItem?.Language?.Description
      } : {},
      SegmentNumber: materialID,
      IsHardParted: dataItem?.IsHardParted ?? false,
      TXReady: dataItem?.TXReady ?? false,
      IsDefault: dataItem?.IsDefault ?? false,
      Archive: dataItem?.Archive ?? false,
      Subtitle: dataItem?.Subtitle ?? false,
      SubtitleType: dataItem?.Subtitle ? dataItem?.SubtitleType : {},
      File: dataItem?.Subtitle ? file?.name : "",
      Remarks: dataItem?.Remarks ? dataItem?.Remarks : "",
      SegmentDetails: segmentDetails.map(item => ({
        ...item, ["TcIn"]: utility.convertStringWithFramesToMilliseconds(item.TcIn),
        ["TcOut"]: utility.convertStringWithFramesToMilliseconds(item.TcOut),
        ["Duration"]: utility.convertStringWithFramesToMilliseconds(item.Duration),
        ["Remarks"]: item?.Remarks ?? ''
      })),
      PgRating: dataItem?.PgRating && Object.keys(dataItem?.PgRating)?.length > 0 ? {
        _id: dataItem.PgRating._id,
        Description: dataItem.PgRating.Description
      } : {},
      Version: dataItem?.Version && Object.keys(dataItem?.Version)?.length > 0 ? {
        _id: dataItem?.Version?._id,
        Name: dataItem?.Version?.Name
      } : {},
      TransmissionType: dataItem?.TransmissionType && Object.keys(dataItem?.TransmissionType).length > 0 ? {
        _id: dataItem?.TransmissionType?._id,
        Name: dataItem?.TransmissionType?.Name,
        IsDefault: dataItem?.TransmissionType?.IsDefault
      } : {},
      IngestPrototype: dataItem?.IngestPrototype,
      TranscodePrototype: dataItem?.TranscodePrototype,
      StorageDetails: dataItem?.StorageDetails && Object.keys(dataItem?.StorageDetails)?.length > 0 ? dataItem?.StorageDetails : {}

    }

    const editIndex = mediaEpisodeSegments.indexOf(editItem)

    if (isNewSegment) {
      let temp = mediaEpisodeSegments;
      if (saveSegmentData.IsDefault) {
        temp = mediaEpisodeSegments.map((segment) => {
          return { ...segment, IsDefault: false }
        })
      }
      let saveData = [...temp, saveSegmentData]
      setMediaEpisodeSegments(() => saveData)
      props.getSegmentData(saveData);
    } else {

      let updatedSegments = mediaEpisodeSegments.map((data, index) => {
        if (editIndex == index) {
          saveSegmentData._id = editItem._id;
          saveSegmentData.SID = editItem.SID;
          return saveSegmentData
        } else {
          data.IsDefault = saveSegmentData.IsDefault ? false : data.IsDefault;
          return data;
        }
      })

      setMediaEpisodeSegments(() => updatedSegments);
      props.getSegmentData(updatedSegments);
    }

    props?.mediaEpisodeEntity?.SID > 0 && onSaveSegments(saveSegmentData);
    setDataItem(() => ({ ...initialValue, SegmentType: defaultSegmentType.current }));
    setSegmentDetails(() => []);
    setEditMode(false);
    setEditToggle(false);
  }

  const calculateSegmentDuration = function (episodeDuration, segmentCount) {

    const [hours, minutes, seconds, msec] = episodeDuration.split(':');
    // let frame = parseInt(msec)/40;
    let hoursToMilliseconds = parseInt(hours) * 3600000;
    let minutesToMilliseconds = parseInt(minutes) * 60000;
    let secondsToMilliseconds = parseInt(seconds) * 1000;

    let convertedMilliseconds = hoursToMilliseconds + minutesToMilliseconds + secondsToMilliseconds + (parseInt(msec) * 40);

    let result = segmentCount === 0 ? new Date('2000', '1', '1', '0', '0', '0') : utility.convertMilisecondsToStringWithFrames(convertedMilliseconds / segmentCount);
    return result;
  }

  const onAddSegmentQC = (dataItem) => {
    setShowQCStatus(true);
    setSegementQCRef(dataItem);
  }

  const onSegmentHistory = (dataItem) => {
    setSegementHistoryRef(dataItem);
    setShowSegmentHistory(true);
  }

  const onCreateIngestWOFile = async (dataItem) => {
    const finalData = {
      mediaSegmentId: dataItem?._id,
      mediaEpisodeId: props?.mediaEpisodeEntity?._id
    }
    const res = await API.createIngestWorkOrder(finalData);
    if (res.success) {
      toast.success(lang.ingest_work_order_exported_successfully_message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
    else {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  const MyCommandCell = (props) => {
    const isValidChannel = utility.isValidSegmentChannelRights(props?.dataItem.Channels)
    return (
      isValidChannel ? <span></span> :
        <MenuCommandCell
          {...props}
          onEdit={onEdit}
          removeSegment={removeSegment}
          myMenuModel={collectionSegmentMenuModel}
          onAddSegmentQC={onAddSegmentQC}
          history={onSegmentHistory}
          createIngestWOFile={onCreateIngestWOFile}
        />
    )
  }

  const MyTimeCell = (props) => <TimeCell {...props} />;


  const removeSegment = async (dataItem) => {
    const index = mediaEpisodeSegments.indexOf(dataItem);

    if (dataItem._id != undefined) {
      let resProgramSchedule = await API.getData(ENTITYNAME.ProgramSchedule, { query: ['Segment_id', '=', dataItem._id] });

      if (resProgramSchedule.data.length != 0) {
        toast.error(
          <div>
            <strong>INVALID</strong>
            <div style={{ fontSize: '13px' }}>{lang.this_segment_is_already_been_scheduled_segmnet_media_episode_error_message}</div>
          </div>
        );
        return;
      } else {
        let res = await API.deleteSegment({ segmentId: dataItem._id });
        if (!res.success) {
          toast.error(<div>
            <strong>INVALID</strong>
            <div style={{ fontSize: '13px' }}>{res.message}</div>
          </div>);
          return;
        }
      }
    }

    // removing from here UI
    setMediaEpisodeSegments(() => mediaEpisodeSegments.filter((data, Index) => {
      if (index != Index) {
        return data
      }
    })
    )

    // removing from main form save list of segments
    props.getSegmentData(mediaEpisodeSegments.filter((data, Index) => {
      if (index != Index) {
        return data
      }
    }));

    // if _id is not generated, means it is just created and not saved in db yet
    // we do not need to use it in delete loop on main save
    if (dataItem._id) {
      // props.handleDeletedSegments(dataItem);
    }
  }

  const generateSegment = function (e) {
    let segmentCount = dataItem.SegmentType.SegmentCount;
    let segmentTypeSuffix = dataItem.SegmentType.Suffix ? dataItem.SegmentType.Suffix : '';

    if (segmentCount) {

      if (props.mediaEpisodeEntity === null || props.mediaEpisodeEntity.Duration === null) {
        toast.error(
          <div>
            <strong>INVALID</strong>
            <div style={{ fontSize: '13px' }}>{lang.media_episode_entity_duration_segment_error_message}</div>
          </div>,
          { position: toast.POSITION.TOP_RIGHT }
        );
        return;
      }

      let segmentDetails = [];
      let episodeDuration = utility.convertMilisecondsToStringWithFrames(props.mediaEpisodeEntity.Duration);
      let actualSegmentDuration = calculateSegmentDuration(episodeDuration, segmentCount)  //to generate the function to calculate segment duration in utility folder

      let durationAsString = actualSegmentDuration;

      for (let cnt = 1; cnt <= segmentCount; cnt++) {

        if (dataItem.IsHardParted) {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = '00:00:00:00';
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        } else {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = segmentDetail.TcIn;
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        }

        let mediaId = !dataItem.IsHardParted ? dataItem.SegmentNumber : segmentTypeSuffix.length > 0 ?
          `${dataItem.SegmentNumber}-${segmentTypeSuffix}-${cnt}-${segmentCount}` :
          `${dataItem.SegmentNumber}-${cnt}-${segmentCount}`;

        if (company.Name && company.Name.toLowerCase() == "rotana") {
          mediaId = !dataItem.IsHardParted ? dataItem.SegmentNumber : segmentTypeSuffix.length > 0 ?
            `${dataItem.SegmentNumber}${segmentTypeSuffix}${cnt.toString().padStart(2, '0')}` :
            `${dataItem.SegmentNumber}${cnt.toString().padStart(2, '0')}`;
        }

        segmentDetails.push({
          Sequence: cnt,
          MediaId: mediaId,  //housenumber-segmentnumber-selectedsegmenttype.count === for mediaID
          TcIn: segmentDetail.TcIn,
          Duration: durationAsString,
          TcOut: segmentDetail.TcOut,
          IsPreviewed: false,
          Remarks: dataItem?.Remarks
        });
        segmentDetail.TcIn = segmentDetail.TcOut;


      }

      setSegmentDetails(segmentDetails);
      setDataItem({ ...dataItem, ["ActualDuration"]: episodeDuration });

    } else {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_select_segment_type_media_episode_version_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
    }

  }

  const updatedSegmentDetails = (updatedData) => {
    setSegmentDetails(updatedData);
  }

  const handleActualDuration = (durationAsString) => {
    dataItem.ActualDuration = durationAsString;
  }

  const clearData = () => {
    setSegmentDetails(() => []);
    setDataItem(() => ({
      ...initialValue,
      SegmentType: defaultSegmentType.current,
      Channels: user && user.Channels?.length == 1 ? channels : []
    }));
    setEditMode(false);
    setEditToggle(false);
  }

  const openForm = () => {
    if (props.mediaEpisodeSID == 0) {
      setDataItem(() => ({ ...initialValue, SegmentType: defaultSegmentType.current }));
    }
    setEditToggle(!editToggle)
  }

  const onUpdateSegement = (item) => {
    let index = mediaEpisodeSegments.findIndex(x => x._id === item._id);
    var data = [...mediaEpisodeSegments];
    data[index] = item;
    setMediaEpisodeSegments(data);
    props.getSegmentData(data);
  }

  const refreshSegmentDetails = () => {
    var newData = segmentDetails.map((x, i) => {
      var item = {
        ...x,
        Sequence: i + 1,
        MediaId: `${dataItem.SegmentNumber}-${i + 1}-${dataItem.SegmentType.SegmentCount}`
      }
      delete item.inEdit;

      return item;
    })
    setSegmentDetails(newData);
  }

  const rowRender = (trElement, props) => {
    let trProps = {};
    let isValidChannel = utility.isValidSegmentChannelRights(props?.dataItem.Channels);
    if (isValidChannel) {
      trProps = {
        ...trProps,
        style: { backgroundColor: "#DDDDDD" }
      };
    }
    return React.cloneElement(trElement, trProps, trElement.props.children);
  };

  const onBrowseMamAsset = (datalist) => {
    console.log("BROWSE MAM");
    let value = datalist[0] && datalist[0].RawData && datalist[0].RawData.id ? datalist[0].RawData.id.toString() : datalist[0]?.SID;
    onChange({ target: { name: "MamID", value: value } });
    if (company.Name && company.Name.toLowerCase() == "smg") {
      //SYNC MAM ASSET
      onSyncMAMAsset(datalist[0].RawData.id.toString());
    }
  }

  const onSyncMAMAsset = async (mamID) => {

    if (!mamID) {
      toast.error("Not Mam ID found !!", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    const payload = {
      MamID: mamID,
      AssetId: props.mediaEpisodeEntity.AssetId
    }

    //CALL SYNC API HERE
    const reponse = await API.syncMediaManagement(payload)

    if (!reponse.success) {
      toast.error(reponse.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    loadSavedSegments();
    toast.success(reponse.message, {
      position: toast.POSITION.TOP_RIGHT
    });

  }

  const onDetachMAMAsset = () => {
    ConfirmAlert(
      () => onChange({ target: { name: "MamID", value: "" } }),
      () => { },
      lang.confirm_button_text,
      lang.detach_mam_asset_confirmation_msg
    );
  }

  const checkInvalidTimecodes = () => {
    if (segmentDetails.length === 0) return false;
    return segmentDetails.some(item => {
      let duration = item.Duration;
      return duration === null || duration === "00:00:00:00" || item.TcIn > item.TcOut;
    });
  }

  const checkExceedingSlotDuration = () => {
    if (segmentDetails.length === 0) return false;
    let isExceeding = props?.mediaEpisodeEntity?.Duration < utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration);
    return isExceeding;
  }

  const checkOverlappingTimecodes = () => {
    if (segmentDetails.length === 0) return false;

    return segmentDetails.some((currentItem, index) => {
      const nextItem = segmentDetails[index + 1];
      if (!nextItem) return false;

      const currentEnd = utility.convertStringWithFramesToMilliseconds(currentItem.TcOut);
      const nextStart = utility.convertStringWithFramesToMilliseconds(nextItem.TcIn);

      return currentEnd > nextStart && !dataItem?.IsHardParted;
    });
  };

  const handleChannelGroups = (groups = []) => {

    const channelGroupsForSave = groups.map(g => ({
      _id: g._id,
      SID: g.SID,
      Description: g.Description
    }));

    const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

    const uniqueChannels = Array.from(
      new Map(linkedChannels.map(ch => [ch._id, ch])).values()
    );

    setDataItem(prev => ({
      ...prev,
      AddFromChannelgroups: channelGroupsForSave,
      Channels: uniqueChannels
    }));
    setSelectAllChannels(uniqueChannels.length === channels.length);

    setShowChannelGroups(false);
  };


  return (<>
    <div className="row form-box">

      <div className={'col-12'}>
        <div style={{ marginTop: "3px", display: "flex", justifyContent: "space-between" }}>
          <div style={{ marginTop: '5px' }}>
            <AddRoundButton onClick={() => setEditToggle(true)} />
            <RoundButton icon={"bolt"} title={"Fast Segmentation"} btnColor={'white'} onClick={() => setFastSegmentationPopupOpen(true)} />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label style={{ whiteSpace: "nowrap" }}>{lang.mamID_label} :</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="MamID"
              value={metaData?.MamID}
              onChange={onChange}
              disabled
              required
            />

            <button placeholder="Attach MAM Asset" title="Attach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
              style={{ height: "30px" }} onClick={() => { setShowMamAssetCollection(true) }}><i className="fa-solid fa-search fa-xs"></i>
            </button>
            {/* <button placeholder="Sync MAM Asset" title="Sync MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              style={{ height: "30px" }} onClick={onSyncMAMAsset}><i className="fa-solid fa-sync fa-xs"></i>
            </button> */}
            <button placeholder="Detach MAM Asset" title="Detach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
              style={{ height: "30px" }} onClick={onDetachMAMAsset}><i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>


        <Grid rowRender={rowRender} data={mediaEpisodeSegments} style={{ height: "53vh" }}>
          <GridColumn cell={MyCommandCell} width="55px" />
          <GridColumn field="SegmentType.Description" title={lang.segment_type_column} editable={false} width="150px" />
          <GridColumn field="SegmentType.TXMode.Name" title={lang.tx_mode_label} editable={false} width="150px" />
          <GridColumn field="Channels" title={lang.channel_label} editable={false} width="200px" cell={ArrayCell} format={"FullChannelName"} />
          <GridColumn field="TransmissionType.Name" title={lang.transmission_type_column} width="150px" />
          <GridColumn field="SegmentNumber" title={lang.material_id_column} editable={false} width="150px" />
          <GridColumn field="ActualDuration" title={lang.actual_duration_column} cell={MyTimeCell} editable={false} width="150px" />
          <GridColumn field="Version.Name" title={lang.version_column} editable={false} width="150px" />
          <GridColumn field="Language.Description" title={lang.language_column} editable={false} width="150px" />
          <GridColumn field="PgRating.Description" title={lang.pg_rating_column} editable={false} width="150px" />
          <GridColumn field="IngestPrototype.Description" title={lang.ingest_prototype_column} width="150px" />
          <GridColumn field="TranscodePrototype.Description" title={lang.transcode_prototype_column} width="180px" />
          <GridColumn field="IsDefault" title={lang.is_default_column} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="Archive" title={lang.archive} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="IsHardParted" title={lang.is_hard_parted_column} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="TXReady" title={lang.transmission_column} cell={MyCheckBoxCell} editable={false} width="150px" />
        </Grid>
        <p className="mt-1">Note: {lang.segment_for_channel_rights_label}</p>
      </div>
      {editToggle && <BossDialog
        title={dialogTitle}
        onClose={clearData}
        width={'950px'}
      // height={'700px'}
      >
        <Form
          render={(formRenderProps) => (
            <FormElement>
              <div className="row">
                <div className="col-7" style={{ display: "flex" }}>
                  {!editMode && <AddRoundButton onClick={() => onAddSegment(true)} />}
                  {editMode && <SaveRoundButton onClick={() => onAddSegment(false)} />}
                  <CancelRoundButton onClick={clearData} />
                  <RefreshButton title={lang.refresh_generated_segments_tooltip} onClick={refreshSegmentDetails} />
                  <h6 style={{ fontWeight: 400, margin: '8px 0px 0px 5px' }}>{`REFERENCE CODE : ${props.mediaEpisodeEntity?.ReferenceCode ?? 'NA'}`}</h6>
                </div>
                <div className='col' style={{ textAlign: 'right' }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label style={{ whiteSpace: "nowrap" }}>{lang.file_label} :</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="FileName"
                      value={dataItem.StorageDetails && dataItem.StorageDetails.FileName ? dataItem.StorageDetails.FileName : ""}
                      onChange={onChange}
                      disabled
                    />
                    <button placeholder="Attach MAM Asset" title="Attach File" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
                      style={{ height: "30px" }} onClick={() => { setShowBucketCollectionSelection(true) }}><i className="fa-solid fa-search fa-xs"></i>
                    </button>
                    <button placeholder="Detach MAM Asset" title="Detach File" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
                      style={{ height: "30px" }} onClick={onDetachFile}><i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-1" style={{ border: "groove 1px" }}>
                <div className="row" style={{ margin: "5px" }}>
                  <div className="col-12 mt-1">
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="TabView">{lang.segment_type_label} *</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={segmentTypes}
                            name="SegmentType"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.SegmentType}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="TabView">{lang.tx_mode_label}</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={Object.keys(TX_MODE)}
                            name="TxMode"
                            value={dataItem?.SegmentType?.TXMode?.Name ?? utility.getKeyByValue(TX_MODE, TX_MODE.TX)}
                            onChange={onChange}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.material_id_label} *</label>
                          <input style={{ height: "32px" }}
                            type="text"
                            className="form-control form-control-sm"
                            name="SegmentNumber"
                            value={dataItem.SegmentNumber}
                            onChange={(e) => onChange(e)}
                            disabled={dataItem.GenerateMaterialID}
                            required
                          />
                        </div>
                      </div>
                      <div className="col form-group">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label className="mb-0">
                            {lang.channel_label} *
                          </label>
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                              title={lang.select_channel_groups_tooltip}
                              onClick={() => setShowChannelGroups(true)}
                              style={{ width: "25px", height: "20px", borderRadius: "50%", padding: 0, marginRight: "5px" }}
                            >
                              <i className="fa fa-layer-group" style={{ fontSize: "13px" }} />
                            </button>
                            <span>
                              {lang.select_all_label}
                              <input
                                type="checkbox"
                                name="IsAllChannel"
                                className="ml-1"
                                value={selectAllChannels}
                                checked={selectAllChannels}
                                onChange={(e) => onChange(e)}
                              />
                            </span>
                          </div>
                        </div>
                        <MultiSelect
                          data={channels}
                          name="Channels"
                          textField="FullChannelName"
                          dataItemKey="_id"
                          value={dataItem.Channels}
                          onChange={onChange}
                          style={{ maxHeight: "65px" }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.language_label}</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={language}
                            name="Language"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Language}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.remark_label}</label>
                          <input style={{ height: "32px" }}
                            type="text"
                            className="form-control form-control-sm"
                            name="Remarks"
                            value={dataItem.Remarks}
                            onChange={(e) => onChange(e)}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.pg_rating_label}</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={pgRatings}
                            name="PgRating"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.PgRating}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.version_label}</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={versions}
                            name="Version"
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.Version}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <div className="form-group">
                          <label htmlFor="">{lang.transmission_type_label} </label>
                          <DropDownList
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={transmissionTypes}
                            name={"TransmissionType"}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.TransmissionType}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label htmlFor="">{lang.ingest_prototype_label} </label>
                          <DropDownList
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={ingestPrototypes}
                            name="IngestPrototype"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.IngestPrototype}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label htmlFor="">{lang.transcode_prototype_label} </label>
                          <DropDownList
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={transcodePrototypes}
                            name="TranscodePrototype"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.TranscodePrototype}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                    </div>

                    <fieldset className="border rounded-4" style={{ padding: '20px 30px', margin: 0 }}  >
                      <div className="row">
                        <div className={dataItem.Subtitle ? "col-3" : 'col-12'} style={dataItem.Subtitle ? { marginTop: '19px' } : {}}>
                          <Field
                            style={{ borderColor: "black" }}
                            name={"Subtitle"}
                            component={Checkbox}
                            label={lang.subtitle_label}
                            onChange={(e) => onChange(e)}
                            checked={dataItem.Subtitle}
                          />
                        </div>
                        {dataItem.Subtitle && <>
                          <div className="col">
                            <label htmlFor="">{lang.subtitle_type_lable} *</label>
                            <DropDownList
                              style={{
                                backgroundColor: "white",
                              }}
                              data={SUBTITLETYPE}
                              name="SubtitleType"
                              textField="Type"
                              dataItemKey="ID"
                              value={dataItem.SubtitleType}
                              onChange={onChange}
                            />
                          </div>
                          <div className="col" style={{ marginTop: '19px' }}>
                            <input
                              name="File"
                              type="text"
                              className="form-control form-control-sm"
                              value={dataItem.File}
                              onChange={onChange}
                              disabled={true}
                            />

                          </div>
                          <div className="col-1">
                            <label
                              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success"
                              style={{ height: "30px", marginTop: "19px" }}
                            >
                              <input
                                ref={fileRef}
                                type="file"
                                name="fileupload"
                                className="custom-file-updated-input"
                                hidden="hidden"
                                id="fileupload"
                                // accept=".srt,.vtt,pdf"
                                onChange={onChange}
                              />
                              {'...'}
                            </label>
                          </div>
                        </>}
                      </div>
                    </fieldset>

                    {!editMode && <fieldset className="border rounded-4" style={{ padding: '20px 30px', margin: '8px 0px 0px 0px' }}  >
                      <div className="row">
                        <div className={dataItem.GenerateMaterialID ? "col-6" : 'col-12'} style={dataItem.GenerateMaterialID ? { marginTop: '19px' } : {}}>
                          <Field
                            style={{ borderColor: "black" }}
                            name={"GenerateMaterialID"}
                            component={Checkbox}
                            label={'Auto Generate Material ID'}
                            onChange={(e) => onChange(e)}
                            checked={dataItem.GenerateMaterialID}
                          />
                        </div>
                        {dataItem.GenerateMaterialID &&
                          <div className="col-6">
                            <label htmlFor="">{lang.material_content_sub_menu} *</label>
                            <DropDownList
                              style={{
                                backgroundColor: "white",
                              }}
                              data={materialContent}
                              name="MaterialContent"
                              textField="Description"
                              dataItemKey="SID"
                              value={dataItem.MaterialContent}
                              onChange={onChange}
                            />
                          </div>}
                      </div>
                    </fieldset>}

                    <div className="row mt-3 mb-2">
                      <div className="col">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsHardParted"}
                          component={Checkbox}
                          label={lang.is_hard_parted_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsHardParted}
                        />
                      </div>
                      <div className="col">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"TXReady"}
                          component={Checkbox}
                          label={lang.transmission_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.TXReady}
                        />
                      </div>
                      <div className="col-2">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"Archive"}
                          component={Checkbox}
                          label={lang.archive}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.Archive}
                        />
                      </div>
                      <div className="col-2">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsDefault"}
                          component={Checkbox}
                          label={lang.is_default_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsDefault}
                        />
                      </div>
                      <div className="col-3" style={{ textAlign: "right" }} >
                        <ActionButton title={lang.generate_segments_button_text} name={lang.generate_segments_button_text} onClick={handleGenerateSegmentClick} />
                      </div>
                    </div>

                    <div className="row mt-3" style={{ marginBottom: "05px" }}>
                      <div className="col-12">
                        {/* to add data list here */}
                        <SegmentTypeCollectionTab
                          mediaDuration={props?.mediaEpisodeEntity?.Duration}
                          segmentDetails={segmentDetails}
                          updatedSegmentDetails={updatedSegmentDetails}
                          handleActualDuration={handleActualDuration}
                          generateSegment={generateSegment}
                          checkExceedingSlotDuration={checkExceedingSlotDuration}
                          checkOverlappingTimecodes={checkOverlappingTimecodes}
                          checkInvalidTimecodes={checkInvalidTimecodes}
                        />
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </FormElement>
          )} />

        {editMode && <h6 className="ml-3 mt-3">{lang.changes_Will_Reflect_in_new_planned_items_only_segmenttype_error_message}</h6>}
      </BossDialog>}
    </div >
    {showQCStatus && <SegmentQC segmentData={segmentQCRef.current} data={props.mediaEpisodeEntity} onClose={() => setShowQCStatus(false)} updateSegement={onUpdateSegement} />}

    {fastSegmentationPopupOpen && <MediaFastSegmentationPopup mediaEpisodeEntity={props.mediaEpisodeEntity} programScheduleEntity={{}} refreshSegments={loadSavedSegments} onClose={() => setFastSegmentationPopupOpen(false)} source={'media'} />}

    {showSegmentHistory && <MediaEpisodeHistory selectedData={props?.mediaEpisodeEntity} segment={segmentHistoryRef.current} closeForm={() => setShowSegmentHistory(false)} />}
    {showMamAssetCollectionSelection && <CollectionSelection entityname={ENTITYNAME.MediaMamAssets} customColumns={MediaMamAssetColumns} title={lang.attach_mam_asset_tooltip} closeForm={() => setShowMamAssetCollection(false)} wherestatement={props.wherestatement ?? ""} setDataList={onBrowseMamAsset} mode={"single"} width={"50vw"} />}

    {showBucketCollectionSelection && <BucketCollectionSelection enableMutliSelection={false} closeForm={() => setShowBucketCollectionSelection(false)} setDataList={onBrowseBucket} mode={"single"} width={"50vw"} />}
    {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}

  </>)
}

export default memo(MediaEpisodeSegmentEditForm);